import { fetchCached, useCachedQuery } from '@/shared/lib/useCachedQuery';
import { getCurrentUser } from '../api/userApi';
import type { CurrentUser } from './types';

/**
 * Ключ кеша `GET /me`. Один на приложение: его делят `useCurrentUser`
 * (`RootRedirect`, `HomePage`) и `LearningLanguageProvider` — на холодном
 * старте уходит один запрос, а не три, и возврат на главную не показывает
 * лоадер «Загружаем профиль» (замер 2026-09-19, см. `PERFORMANCE_PLAN.md`, R-1).
 *
 * Сбрасывается при смене изучаемого языка (`invalidateCache()` целиком) и
 * после онбординга. Поля, которые меняются по ходу (пройден ли онбординг,
 * часовой пояс), правятся на месте через `updateCache`, без похода в сеть.
 */
export const CURRENT_USER_CACHE_KEY = 'user:me';

export function loadCurrentUser(): Promise<CurrentUser> {
  return fetchCached(CURRENT_USER_CACHE_KEY, () => getCurrentUser());
}

export function useCurrentUser() {
  const { data, error, isLoading, reload } = useCachedQuery(CURRENT_USER_CACHE_KEY, () => getCurrentUser());
  return { user: data, error: isLoading ? null : error, isLoading, reload };
}
